import axios, {AxiosInstance} from "axios";
import objectToFormData from "../helpers/objectToFormData";

class ApiServiceV2 {
    private instance: AxiosInstance;

    constructor() {
        let wrapper = document.getElementById('zr-wrapper')
        let url = '/'
        
        if (wrapper && wrapper.dataset.api) {
            url = wrapper.dataset.api
        } else {
            const contactFormWrapper = document.querySelector('[id^="zr-contact-form-frontend-"]') as HTMLElement
            if (contactFormWrapper && contactFormWrapper.dataset.apiUrl) {
                url = contactFormWrapper.dataset.apiUrl
            }
        }

        this.instance = axios.create({
            baseURL: url,
        })
    }

    async callApi(route: string, method = 'get', data: object = {}, files: Blob[] = []) {
        return await this.instance.request({
            method: method,
            url: route,
            data: objectToFormData({...data, ...files}),
            responseType: "json"
        })
    }
}

export default ApiServiceV2;
